export type AerosyncPreAuthContextType = {
  triggerPreAuthFlow: (paymentMethodId: string) => Promise<void>;
};

export type AerosyncPreAuthProviderProps = {
  children: React.ReactNode;
};

export enum PusherStatus {
  mfaRequired = 'STATUS_MFA_REQUIRED',
  statusReady = 'STATUS_READY',
  statusFailed = 'STATUS_FAILED',
}

export type PusherPreAuthEvent = {
  status: PusherStatus;
  meta: {
    aeroPassUserUuid: string;
    token: string;
    connectionId: string;
    jobId: string;
  };
};
